import { useEffect, useState } from 'react';
import { SHOPIFY_ENABLED, fetchProducts, fetchProductByHandle } from '../lib/shopify';
import { PRODUCTS as MOCK } from '../data/mock';

let _cache = null;

export function useProducts() {
  const [state, setState] = useState({ products: _cache || MOCK, loading: !_cache && SHOPIFY_ENABLED, source: _cache ? 'shopify' : 'mock' });

  useEffect(() => {
    if (!SHOPIFY_ENABLED || _cache) return;
    let cancelled = false;
    (async () => {
      try {
        const list = await fetchProducts(100);
        if (cancelled) return;
        if (list.length > 0) {
          _cache = list;
          setState({ products: list, loading: false, source: 'shopify' });
        } else {
          setState({ products: MOCK, loading: false, source: 'mock' });
        }
      } catch (e) {
        console.warn('Shopify fetch failed, using mock', e);
        if (!cancelled) setState({ products: MOCK, loading: false, source: 'mock' });
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return state;
}

export function useProduct(handle) {
  const [state, setState] = useState({ product: MOCK.find((p) => p.id === handle) || null, loading: SHOPIFY_ENABLED });
  useEffect(() => {
    if (!SHOPIFY_ENABLED) return;
    let cancelled = false;
    (async () => {
      try {
        const p = await fetchProductByHandle(handle);
        if (cancelled) return;
        if (p) setState({ product: p, loading: false });
        else setState((s) => ({ product: s.product, loading: false }));
      } catch {
        if (!cancelled) setState((s) => ({ product: s.product, loading: false }));
      }
    })();
    return () => { cancelled = true; };
  }, [handle]);
  return state;
}
